<template>
  <div class="container-fluid" style="padding-left: 0px; padding-right: 0px;">
    <div class="pageContainer">
      <div class="row">
        <div class="col-sm-4">
          <div class="itemsGroup">
            <div class="itemsList">
              <dt class="item">Make</dt>
              <dd class="item">{{ asset.make }}</dd>
            </div>
            <div class="itemsList">
              <dt class="item">Model</dt>
              <dd class="item">{{ asset.model }}</dd>
            </div>
            <div class="itemsList">
              <dt class="item">Serial</dt>
              <dd class="item">{{ asset.serial }}</dd>
            </div>
            <div class="itemsList">
              <dt class="item">Reference</dt>
              <dd class="item">{{ asset.name }}</dd>
            </div>
            
          </div>
        </div>
        <div class="col-sm-4">
          <div class="itemsGroup">
            <div class="itemsList">
              <dt class="item">Refrigeration Quantity (KG)</dt>
              <dd class="item">{{ asset.refrigeration_quantity_kg }}</dd>
            </div>
            <div class="itemsList">
              <dt class="item">Refrigeration Type</dt>
              <dd class="item">{{ asset.refrigeration_type }}</dd>
            </div>
            <div class="itemsList">
              <dt class="item">Year of install</dt>
              <dd class="item">{{ asset.year_installed }}</dd>
            </div>
          </div>
        </div>
        <div class="col-sm-1"></div>
        <div class="col-sm-3">
          <div class="row">
            <div class="col-sm-12">
              <a href="#" @click.prevent="$openPdf('fgas-log', asset.id)" class="btnOrderAction">F-Gas Log Book <font-awesome-icon icon="angle-double-right" /></a>
            </div>
          </div>
          <div class="row" style="margin-top: 20px;">
            <div class="col-sm-12">
              <a href="#" @click.prevent="$openPdf('fgas-record-sheet', asset.id)" class="btnOrderAction">F-Gas Record Sheet <font-awesome-icon icon="angle-double-right" /></a>
            </div>
          </div>
          <div class="row" style="margin-top: 20px;">
            <div class="col-sm-12">
              <router-link :to="{name: 'AssetsFgasAdd', params: { id: $route.params.id }}" class="btnOrderAction">Add Gas <font-awesome-icon icon="angle-double-right" /></router-link>
            </div>
          </div>
        </div>
      </div>
    </div>
    <header>
      <div class="row">
        <div class="col-sm-12">
          <ul class="filterNav">
            <router-link :to="{name: 'AssetsJobs', params: { id: $route.params.id }}"><li>Jobs</li></router-link>
            <router-link :to="{name: 'AssetsLeak', params: { id: $route.params.id }}"><li>Leak Cheaks</li></router-link>
            <router-link :to="{name: 'AssetsFgas', params: { id: $route.params.id }}"><li>Gas Movements</li></router-link>
            <router-link :to="{name: 'AssetsMaintenanceChecks', params: { id: $route.params.id }}"><li>Maintenance Checklists</li></router-link>
            
          </ul>
        </div>
      </div>
    </header>
  </div>
</template>

<script>

import axios from 'axios'

export default {
  data () {
    return {
      asset: {}
    }
  },
  created () {
    axios
      .get(`/api/assets/${this.$route.params.id}`)
      .then((res) => {
        this.asset = res.data
      })
  },
  methods: {
  }
}
</script>
